var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashPaymentSign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cash Payment Sign 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6867 26.0617L7.5 26.945L8.38333 20.7584L24.2933 4.84836C24.6416 4.50013 25.055 4.22391 25.5099 4.03545C25.9649 3.847 26.4525 3.75 26.945 3.75C27.4375 3.75 27.9251 3.847 28.3801 4.03545C28.835 4.22391 29.2484 4.50013 29.5967 4.84836C29.9449 5.19658 30.2211 5.60998 30.4096 6.06495C30.598 6.51993 30.695 7.00756 30.695 7.50002C30.695 7.99248 30.598 8.48012 30.4096 8.93509C30.2211 9.39007 29.9449 9.80347 29.5967 10.1517L13.6867 26.0617Z",
    stroke: "#040506",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 13.75H3.75C3.08696 13.75 2.45107 14.0134 1.98223 14.4822C1.51339 14.9511 1.25 15.587 1.25 16.25V33.75C1.25 34.413 1.51339 35.0489 1.98223 35.5178C2.45107 35.9866 3.08696 36.25 3.75 36.25H36.25C36.913 36.25 37.5489 35.9866 38.0178 35.5178C38.4866 35.0489 38.75 34.413 38.75 33.75V16.25C38.75 15.587 38.4866 14.9511 38.0178 14.4822C37.5489 14.0134 36.913 13.75 36.25 13.75H33.75",
    stroke: "#040506",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.75 30H21.25",
    stroke: "#040506",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M33.75 23.75H26.25",
    stroke: "#040506",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPaymentSign);
export default __webpack_public_path__ + "static/media/cash-payment-sign.4ae4ef2a2cc372e54f42f402f12cc5d2.svg";
export { ForwardRef as ReactComponent };